﻿class I18n {
  resources: any[];
  fallbackLng: string;
  lang: string;

  init = (options: any) => {
    this.resources = options && options.resources;
    this.fallbackLng = options && options.fallbackLng;
  }

  changeLanguage = (lang: string) => {
    this.lang = lang;
  }

  translate = (key: string) => {
    let resources = this.resources && this.resources[this.lang || this.fallbackLng];
    return resources && resources.translations && resources.translations[key];
  }
}

const i18n = new I18n();

i18n.init({
  // we init with resources
  resources: {
    en: {
      translations: {
        "1": "Welcome to our chatbot!",
        "2": "If you are looking for something in particular then ask me a question and I will do my best to help.",
        "3": "Start a chat",
        "4": "To start a chat with me, please click on the button below.",
        "5": "Start chat",
        "6": "Continue chat",
        "7": "Chatbot",
        "8": "Active",
        "9": "No Active",
        "10": "Hi! How can I help you today?",
        "11": "How can I help you today?",
        "12": "",
        "13": "Thanks!",
        "14": "Uploaded File",
        "15": "Closed chat",
        "16": "Choose an option",
        "17": "Text a message",
        "18": "Close chat"
      }
    }
  },
  fallbackLng: "en",
});

export default i18n;
